import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class SessionStorageService {

  constructor() { }

  storeData(key: string, data: any) {
    sessionStorage.setItem(key, data);
  }

  getStoredData(key: string) {
    return sessionStorage.getItem(key);
  }

  clearStorage(key: string) {
    sessionStorage.removeItem(key);
  }

  cleanStorage() {
    try {
      sessionStorage.clear();
    } catch  {
        // ignore errors if we dont have permission to storage!
    }
  }
}
